import OfflineFileWrapper from "../../../../components/OfflineFileWrapper";
import { HoverImage, LabelColumnV2, MultiLabelColumnV2 } from "../../../../components/DataGridV2/DataColumnsV2";
import { Box, Tooltip } from "@mui/material";
import { Cancel, CheckCircle, Image } from "@mui/icons-material";
import { URLS } from "../../../../apis/urls";
import { Button } from "@mui/material";
import { getGridContextMenuList } from "../../../../_helpers/getGridContextMenuList";
import { formatDate, formatDateForFilter} from "../../../../_helpers";
import { LOCAL_STORAGE_GRID_KEYS } from "../../../../_constants";

export const getSecondSignatureRepairRequestColumns = ({
    t,
    theme,
    keyPrefix,
    i18n,
    apiRef,
    detailDialogOpenHandler,
    locations,
    statusOptions,
    classes,
    rrDbStatuses
}) => {
    const getOptions = getGridContextMenuList({
        filterKey: LOCAL_STORAGE_GRID_KEYS.SECOND_SIGNATURE_REPAIR_REQUESTS_COLUMN_FILTER[keyPrefix],
        sortKey: LOCAL_STORAGE_GRID_KEYS.SECOND_SIGNATURE_REPAIR_REQUESTS_COLUMN_SORT[keyPrefix],
        i18n,
        t,
        apiRef,
        mode: "client",
        getValueForFilter: (rowData, extraData) => {
            let value = ""
            switch (extraData.fieldName) {
                case "date":
                    value = formatDateForFilter(rowData.date)
                    break;
                default:
                    value = rowData[extraData.fieldName]
                    break;
            }
            return value
        },
        getValueForCopy: (rowData, extraData) => {
            let value = ""
            switch (extraData.fieldName) {
                case "targetCompletionDate":
                    value = rowData?.targetCompletionDate ? formatDate(new Date(rowData?.targetCompletionDate)) : ""
                    break;
                case "date":
                    value = rowData.date ? formatDate(new Date(rowData.date)) : ""
                    break;
                default:
                    value = rowData?.[extraData?.fieldName]
                    break;
            }
            return value
        }
    })
    return [
        {
            download: false,
            print: true,
            field: "attachments",
            headerName: t("general.image"),
            editable: false,
            disableColumnMenu: true,
            flex: 1,
            align: "center",
            filterable: false,
            sortable: false,
            minWidth: 45,
            maxWidth: 45,
            forceApplyWidth: true,
            renderCell: (params) => {
                const request = params.row;
                if (!request) return "";
                let imageURL = "";
                let attachmentId;
                if (
                    request &&
                    request.sync === 0 &&
                    request.attachments &&
                    request.attachments.length
                ) {
                    imageURL = `${window.URL.createObjectURL(
                        new Blob([request.attachments[0]])
                    )}`;
                } else if (
                    request &&
                    request.sync !== 0 &&
                    request.attachments &&
                    request.attachments.length
                ) {
                        attachmentId = request.attachments[0].attachmentId;
                        imageURL = `${URLS.GET_ATTACHMENT_THUMBNAIL}${request.attachments[0].attachmentId}`;
                }

                return (
                    <>
                        <OfflineFileWrapper id={attachmentId} url={imageURL}>
                            {(url) => (
                                <HoverImage
                                    defaultSize={20}
                                    imageId={attachmentId}
                                    index={params.rowIndex || params.id}
                                />
                            )}
                        </OfflineFileWrapper>
                    </>
                );
            },
            renderHeader: () => (
                <Box sx={{ textAlign: "center" }}>
                    <Image />
                </Box>
            ),
        },
        {
            download: true,
            print: true,
            field: "number",
            headerName: t("general.number"),
            flex: 1,
            minWidth: 108,
            renderCell: (params) => {
                const request = params.row;
                if (!request) return "";
                return (
                    <LabelColumnV2
                        label={<Button
                            onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                detailDialogOpenHandler(request);
                            }}
                          className={classes.colorPrimary}
                        >
                           {t(request.number)}
                        </Button>
                        }
                        cellSubMenuOptions={{ options: getOptions({ field: "number", isQuickFilterDisplay: Boolean(request.number) }), extraData: { fieldName: "number" } }}
                        request={request}
                    />
                );
            },
        },
        {
                download: true,
                print: true,
                field: "location",
                headerName: t("general.location"),
                flex: 1,
                align: "start",
                minWidth: 108,
                editable: false,
                disableRowSelectionOnClick: true,
                type: "singleSelect",
                valueOptions: locations,
                renderCell: (params) => {
                    const request = params.row;
                    if (!request) return "";
                    return (
                        <LabelColumnV2
                            label={request.location}
                            sx={{ minWidth: "108px" }}
                            cellSubMenuOptions={{ options: getOptions({ field: "location", isQuickFilterDisplay: Boolean(request.location) }), extraData: { fieldName: "location", type: 'singleSelect' } }}
                            request={request}
                        />
                    );
                },
        },
        {
            field: "date",
            download: true,
            type: "date",
            valueGetter: (params) => {
                if (!params) return "";
                return new Date(params);
            },
            headerName: t("general.date"),
            flex: 1,
            minWidth: 90,
            renderCell: (params) => {
                const rowData = params?.row;
                if (!rowData) return "";
                return (
                    <LabelColumnV2 label={rowData?.date ? formatDate(new Date(rowData?.date)) : ""}
                        cellSubMenuOptions={{ options: getOptions({ field: "date", isQuickFilterDisplay: rowData?.date }), extraData: { fieldName: "date", type: "date" } }}
                        request={rowData}
                    />
                )
            },
        },
        {
            download: true,
            print: true,
            field: "desc",
            headerName: t("general.description"),
            flex: 1,
            align: "start",
            minWidth: 100,
            renderCell: (params) => {
                const request = params.row;
                if (!request) return "";
                return (
                    <LabelColumnV2
                        label={request.desc}
                        cellSubMenuOptions={{ options: getOptions({ field: "desc", isQuickFilterDisplay: Boolean(request.detailDesc) }), extraData: { fieldName: "desc" } }}
                        request={request}
                        sx={{ minWidth: "265px" }}
                    />
                );
            },
        },
        {
            download: true,
            print: true,
            field: "textResolvers",
            headerName: t("general.resolvers"),
            minWidth: 142,
            editable: false,
            filterable:false,
            flex: 1,
            align: "start",
            sortable: false,
            renderCell: (params) => {
                const request = params.row;
                if (!request) return "";
                return (
                    <MultiLabelColumnV2
                        data={request.resolvers.map((x) => ({name:x.name}))}
                        cellSubMenuOptions={{ options: getOptions({ sortable: false,filterable:false, field: "textResolvers", isQuickFilterDisplay: false}), extraData: { fieldName: "textResolvers",  } }}
                        request={request}
                        sx={{ minWidth: "142px" }}
                    />
                );
            },
        },
        {
            download: true,
            print: true,
            field: "targetCompletionDate",
            headerName: t("repairRequest.targetCompletionDate.shortLabel"),
            flex: 1,
            minWidth: 90,
            type: "date",
            valueGetter: (params) => {
                if (!params) return "";
                return new Date(params);
            },
            renderCell: (params) => {
                const rowData = params.row;
                if (!rowData) return "";
                return (
                    <LabelColumnV2
                        date={rowData.targetCompletionDate}
                        cellSubMenuOptions={{ options: getOptions({ field: "targetCompletionDate", isQuickFilterDisplay: rowData?.targetCompletionDate }), extraData: { fieldName: "targetCompletionDate", type: "date" } }}
                        request={rowData}
                    />
                );
            },
        },
        {
            download: true,
            print: true,
            field: "status",
            headerName: t("general.status"),
            flex: 1,
            align: "start",
            type: "singleSelect",
            valueOptions: statusOptions,
            minWidth: 90,
            renderCell: (params) => {
                const request = params.row;
                if (!request) return "";
                return (
                    <LabelColumnV2
                        label={<span
                            style={{
                                color:
                                    request.status === rrDbStatuses.COMPLETED
                                        ? theme.palette.success.main
                                        : "inherit",
                            }}
                        >
                            {request.status}
                        </span>}
                        cellSubMenuOptions={{ options: getOptions({ field: "status", isQuickFilterDisplay: Boolean(request.status) }), extraData: { fieldName: "status", type: 'singleSelect' } }}
                        request={request}
                    />
                );
            },
        },
        {
            download: true,
            print: true,
            field: "buyerField",
            headerName: t("repairRequest.buyerStatus"),
            flex: 1,
            align: "start",
            minWidth: 90,
            renderCell: (params) => {
                const request = params.row;
                if (!request) return "";

                if (request.completedByBuyer) {
                    return (
                        <Tooltip title={request.status}>
                            <CheckCircle color="success" />
                        </Tooltip>
                    );
                } else if (request.isRework) {
                    return (
                        <Tooltip title={request.status}>
                            <Cancel color="error" />
                        </Tooltip>
                    );
                }
                return "";
            }
        },
    ];
}

